import React, { useState, useEffect } from "react";
import { Hide, Show } from "react-iconly";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./resetPassword.scss";
import { resetPassword } from "../../services/auth.service";
import { toast } from "react-toastify";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch } from "react-redux";

const ResetPassword = (props) => {
  const [input, setInput] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear validation error for the current field
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!input.password || input.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
      valid = false;
    }

    if (!input.confirmPassword || input.confirmPassword.length < 6) {
      newErrors.confirmPassword =
        "Confirm Password must be at least 6 characters long";
      valid = false;
    }

    if (input.password !== input.confirmPassword) {
      newErrors.confirmPassword =
        "Password and Confirm Password does not match";
      valid = false;
    }

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/;
    if (!passwordRegex.test(input.password)) {
        newErrors.password =
            "Password must be at least 6 characters long, contain at least one digit, and at least one special character";
        valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = validateForm();
    if (valid) {
      let inputs = input;
      const storedData = localStorage.getItem("emailForforget");
      inputs.email = storedData;
      try {
        await dispatch(setLoader(true));
        const res = await resetPassword(inputs);
        if (res?.data?.status === true) {
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          //   props.setSignUpModal(false)
          props.setSignUpModal(true);
          props.setResetPasswordModal(false);
          localStorage.clear("emailForforget");
          await dispatch(setLoader(false));
        } else {
          await dispatch(setLoader(false));
          toast.warning(res.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        await dispatch(setLoader(false));
      } catch (e) {
        await dispatch(setLoader(false));
        console.log("error", e);
      }
    }
  };

  return (
    <>
      <Modal
        size="sm"
        show={props.setResetPasswordModal}
        onHide={() => props.setResetPasswordModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Reset Password</h2>
          <div className="modal-sub-title">
            Welcome to Helpr! We are here to help with your <br /> service
            requests.
          </div>
          <Form
            className="modal-form-wrapper"
            onSubmit={(e) => handleSubmit(e)}
          >
            <Form.Group className="mb-3" controlId="password">
              <Form.Label>New password</Form.Label>
              <div className="form-wrap">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter your new password"
                />
                <div
                  className="icon-wrap"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ?  <Show />: <Hide />}{" "}
                  {/* Toggle between hide and show icons */}
                </div>
              </div>
              {errors.password && <p className="error">{errors.password}</p>}
            </Form.Group>
            <Form.Group className="mb-4" controlId="confirmPassword">
              <Form.Label>Confirm New password</Form.Label>
              <div className="form-wrap">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  onChange={handleChange}
                  placeholder="Enter your new password"
                />
                <div
                  className="icon-wrap"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <Show />: <Hide />  }
                </div>
              </div>
              {errors.confirmPassword && (
                <p className="error">{errors.confirmPassword}</p>
              )}
            </Form.Group>
            <Form.Group className="mb-4">
              <div className="d-grid">
                <Button type="submit" variant="primary" size="lg">
                  Submit
                </Button>
              </div>
            </Form.Group>
            <div
              className="form-footer text-center w-100 mb-2"
              onClick={() => {
                props.setSignUpModal(true);
                props.setResetPasswordModal(false);
              }}
            >
              Back to login? <span>Login page</span>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResetPassword;
